import { Label } from '@procurify/ui'

import { UnbilledItemPOLabel } from '@webapp/components/UnbilledItemPOLabel'
import { BridgeLink } from '@webapp/core/components/BridgeLink'
import { type ColumnTypeData } from '../../types/DataTable.types'

export const UnbilledItemRefCell = ({
  item,
}: {
  item: ColumnTypeData['UNBILLEDITEM_REF']
}) => {
  if (item?.po?.number) {
    return (
      <div onClick={(e) => e.stopPropagation()}>
        <BridgeLink to={`/#/purchase/order/details/${item.po.uuid}`}>
          <UnbilledItemPOLabel
            poNumber={item.po.number}
            orderItem={item.orderitem}
          />
        </BridgeLink>
      </div>
    )
  }

  if (item?.expense_report?.id) {
    return (
      <a
        href={`/#/expenses/${item.expense_report.uuid}`}
        onClick={(e) => e.stopPropagation()}
      >
        <Label label='RFE'>{item.expense_report.id}</Label>
      </a>
    )
  }

  return null
}

UnbilledItemRefCell.displayName = 'UnbilledItemRefCell'
